export const entity_language = {
    entity: {
        user: 'Utenti',
        user_group: 'Gruppi',
        user_entity_saved_filters: 'Filtri salvati',
        user_entity_preferences: 'Preferenze entità',
        log: 'Log di sistema',
        voyage: 'Viaggi',
        gyv_voyage: 'Viaggi',
        terminal: 'Terminal',
        operatore_di_varco: 'Operatori di varco',
        transitario: 'Transitari',
        receipt_sender: 'Mittenti fattura',
        receipt: 'Storico esportazioni',
        receipt_files: 'File fatture',
        voyage_documents: 'Documenti viaggio',
        import_history: 'Storico importazioni',
        gyv_voyage_double: 'Viaggi duplicati'
    },
    labels: {
        "user": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idUserGroup": 'Gruppo',
            "name": 'Nome',
            "surname": 'Cognome',
            "username": 'Username',
            "email": 'Email',
            "level": 'Livello utente',
            "avatar": 'Avatar',
            "password": 'Password',
            "level.options.0": "Amministratore",
            "level.options.1": "Utente varco",
        },
        "user_group": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome gruppo',
            "idOperatore": 'Operatore'
        },
        "user_entity_saved_filters": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "author": 'Utente',
            "entity": 'Entità',
            "name": 'Nome',
            "notes": 'Note',
            "content": 'Json filtri'
        },
        "user_entity_preferences": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "author": 'Utente',
            "entity": 'Entità',
            "content": 'Json preferenze'
        },
        "log": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idItem": 'Id elemento',
            "idUser": 'Utente',
            "entity": 'Entità',
            "operation": 'Operazione',
            "operation.options.0_DELETE": 'Elimina',
            "operation.options.1_EDIT": 'Modifica',
            "operation.options.2_ADD": 'Aggiungi',
            "operation.options.3_LOGIN": 'Login',
            "operation.options.4_LOGOUT": 'Logout',
            "notes": 'Note',
        },
        "voyage": {
            "id": 'id',
            "date": 'Data inserimento',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idUserGroup": 'Gruppo Operatore',
            "author": 'Operatore',
            "voyageDateTime": 'Data viaggio',
            "ciclo": 'Ciclo',
            "ciclo.options.IMPORT": 'IMPORT',
            "ciclo.options.EXPORT": 'EXPORT',
            "ciclo.options.EMPTY_RELEASE_IN": 'EMPTY RELEASE IN',
            "ciclo.options.EMPTY_RELEASE_OUT": 'EMPTY RELEASE OUT',
            "riferimento_merce": 'Riferimento merce',
            "tipo_merce": 'Tipo merce',
            "tipo_merce.options.CONTAINER": 'CONTAINER',
            "tipo_merce.options.TRAILER": 'TRAILER',
            "tipo_merce.options.ROTABILE": 'ROTABILE',
            "tipo_merce.options.BULK": 'BULK',
            "tipo_merce.options.OTHER_WITH_ID": 'OTHER WITH ID',
            "tipo_merce.options.TRENO": 'TRENO',
            "tipologia_contenitore": 'Tipologia contenitore',
            "tipologia_contenitore.options.N": 'NORMALE',
            "tipologia_contenitore.options.Y": 'MAGGIORAZIONE',
            "tipologia_contenitore.options.OT": 'OPEN TOP',
            "tipologia_contenitore.options.BB": 'BREAK BULK',
            "notes": 'Note',
            "customerReference": 'Codice cliente',
            "idTerminal": 'Terminal',
            "idOperatore": 'Operatore di varco',
            "idTransitario": 'Transitario',
            "ship": 'Dettaglio nave',
            "invoice": 'Da fatturare',
            "invoice.options.YES": 'Sì',
            "invoice.options.NO": 'No',
            "ignoreDouble": 'Ignora doppioni'
        },
        "gyv_voyage": {
            "id": 'id',
            "date": 'Data inserimento',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idUserGroup": 'Gruppo Operatore',
            "author": 'id Operatore',
            "operatorUsername": 'Operatore',
            "voyageDateTime": 'Data viaggio',
            "ciclo": 'Ciclo',
            "ciclo.options.IMPORT": 'IMPORT',
            "ciclo.options.EXPORT": 'EXPORT',
            "ciclo.options.EMPTY_RELEASE_IN": 'EMPTY RELEASE IN',
            "ciclo.options.EMPTY_RELEASE_OUT": 'EMPTY RELEASE OUT',
            "riferimento_merce": 'Riferimento merce',
            "tipo_merce": 'Tipo merce',
            "tipo_merce.options.CONTAINER": 'CONTAINER',
            "tipo_merce.options.TRAILER": 'TRAILER',
            "tipo_merce.options.ROTABILE": 'ROTABILE',
            "tipo_merce.options.BULK": 'BULK',
            "tipo_merce.options.OTHER_WITH_ID": 'OTHER WITH ID',
            "tipo_merce.options.TRENO": 'TRENO',
            "tipologia_contenitore": 'Tipologia contenitore',
            "tipologia_contenitore.options.N": 'NORMALE',
            "tipologia_contenitore.options.Y": 'MAGGIORAZIONE',
            "tipologia_contenitore.options.OT": 'OPEN TOP',
            "tipologia_contenitore.options.BB": 'BREAK BULK',
            "notes": 'Note',
            "customerReference": 'Codice cliente',
            "idTerminal": 'id Terminal',
            "terminalName": 'Terminal',
            "terminalVatNumber": 'Terminal Piva',
            "idOperatore": 'Operatore di varco',
            "idTransitario": 'id Transitario',
            "transitarioName": 'Transitario',
            "transitarioVatNumber": 'Transitario Piva',
            "ship": 'Dettaglio nave',
            "invoice": 'Da fatturare',
            "invoice.options.YES": 'Sì',
            "invoice.options.NO": 'No'
        },
        "terminal": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome terminal',
            "vatNumber": 'Partita IVA terminal',
            "tariffa_viaggio": 'Tariffa N',
            "tariffa_maggiorazione": 'Tariffa Y',
            "tariffa_open": 'Tariffa OT',
            "tariffa_break": 'Tariffa BB'
        },
        "operatore_di_varco": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "paeseIva": 'Paese partita IVA',
            "paeseIva.options.0": 'IT',
            "codiceIva": 'Codice partita IVA',
            "denominazione": 'Denominazione',
            "regimeFiscale": 'Regime fiscale',
            "indirizzoSede": 'Indirizzo sede',
            "capSede": 'CAP sede',
            "comuneSede": 'Comune sede',
            "provinciaSede": 'Provincia (Sigla)',
            "nazioneSede": 'Nazione (Sigla)',
            "telefono": 'Telefono',
            "email": 'Email',
        },
        "transitario": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome transitario',
            "vatNumber": 'Partita IVA'
        },
        "receipt_sender": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "terminal": 'Terminal',
            "paeseIva": 'Paese partita IVA',
            "paeseIva.options.0": 'IT',
            "codiceIva": 'Codice partita IVA',
            "denominazione": 'Denominazione',
            "regimeFiscale": 'Regime fiscale',
            "indirizzoSede": 'Indirizzo sede',
            "capSede": 'CAP sede',
            "comuneSede": 'Comune sede',
            "provinciaSede": 'Provincia sede',
            "regioneSede": 'Regione sede',
            "nazioneSede": 'Nazione sede',
            "email": 'Email',
            "telefono": 'Telefono',
            "iban": 'IBAN',
            "istitutoFinanziario": 'Istituto finanziario',
        },
        "receipt": {
            "id": 'id',
            "date": 'Data esportazione',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "mittente": 'Mittente',
            "operatore": 'Operatore',
            "tipo": 'Tipo',
            "aliquota": 'Aliquota',
            "totale_fattura": 'Importo fattura',
            "xml": 'XML',
            "files": 'File',
            "mese": 'Mese riferimento',
            "anno": 'Anno riferimento',
            "viaggi": 'Numero viaggi'
        },
        "receipt_files": {
            "id": 'id',
            "date": 'Data esportazione',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome file',
            "file": 'File',
            "notes": 'Note'
        },
        "voyage_documents": {
            "id": 'id',
            "date": 'Data creazione',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "type": 'Tipo file',
            "type.options.T1": 'T1',
            "type.options.LDV": 'Lettera di vettura',
            "type.options.DO": 'Delivery order',
            "type.options.MP": 'Merci pericolose',
            "type.options.CRT": 'Certificato',
            "type.options.DAA": 'DAA',
            "type.options.CAR": 'Carnet',
            "type.options.IC": 'Interchange',
            "type.options.ALT": 'Altro',
            "file": 'File',
            "idUserGroup": 'Azienda',
            "driverSignature": 'Firma autista'
        },
        "import_history": {
            "id": 'id',
            "date": 'Data importazione',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "totalRow": 'Righe totali',
            "insertRow": 'Righe inserite',
            "modifyRow": 'Righe modificate',
            "errorRow": 'Righe con errore',
            "result": 'Risultato importazione',
            "result.options.0": 'Errore',
            "result.options.1": 'Successo',
            "errorImport": 'Messaggio di errore'
        },
        "gyv_voyage_double": {
            "id": 'id',
            "date": 'Data inserimento',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idUserGroup": 'Gruppo Operatore',
            "author": 'Operatore',
            "voyageDateTime": 'Data viaggio',
            "ciclo": 'Ciclo',
            "ciclo.options.IMPORT": 'IMPORT',
            "ciclo.options.EXPORT": 'EXPORT',
            "ciclo.options.EMPTY_RELEASE_IN": 'EMPTY RELEASE IN',
            "ciclo.options.EMPTY_RELEASE_OUT": 'EMPTY RELEASE OUT',
            "riferimento_merce": 'Riferimento merce',
            "tipo_merce": 'Tipo merce',
            "tipo_merce.options.CONTAINER": 'CONTAINER',
            "tipo_merce.options.TRAILER": 'TRAILER',
            "tipo_merce.options.ROTABILE": 'ROTABILE',
            "tipo_merce.options.BULK": 'BULK',
            "tipo_merce.options.OTHER_WITH_ID": 'OTHER WITH ID',
            "tipo_merce.options.TRENO": 'TRENO',
            "tipologia_contenitore": 'Tipologia contenitore',
            "tipologia_contenitore.options.N": 'NORMALE',
            "tipologia_contenitore.options.Y": 'MAGGIORAZIONE',
            "tipologia_contenitore.options.OT": 'OPEN TOP',
            "tipologia_contenitore.options.BB": 'BREAK BULK',
            "notes": 'Note',
            "customerReference": 'Codice cliente',
            "terminal": 'Terminal',
            "operatore": 'Operatore di varco',
            "transitario": 'Transitario',
            "ship": 'Dettaglio nave',
            "invoice": 'Da fatturare',
            "invoice.options.YES": 'Sì',
            "invoice.options.NO": 'No'
        },
    }
};